<template>
  <div class="search-result-wrap">
    <NavHeaderBar title="搜索结果" rightArrow />
    <!-- <SearchInput
      :searchValue="$route.query.key"
      @search="onSearch"
      @cancel="onCancel"
    /> -->
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="searchActive ? '没有更多了' : ''"
      @load="fetchSearch"
    >
      <template v-if="searchActive">
        <SearchContent :searchContent="searchContent" />
      </template>
      <Default v-else />
    </van-list>
  </div>
</template>

<script>
import apis from "@/config/apis";
export default {
  name: "SearchResult",
  data: () => ({
    searchPage: 1,
    searchContent: [],
    searchActive: true,
    loading: false,
    finished: false
  }),
  computed: {
    searchKey() {
      const { key } = this.$route.query;
      return key || null;
    }
  },

  methods: {
    async fetchSearch() {
      try {
        const resp = await apis.list.searchList({
          size: 10,
          page: this.searchPage,
          title: this.searchKey
        });
        const { courselist, total } = resp;
        this.loading = false;
        if (total > 0) {
          this.searchActive = true;
          this.searchContent = [...this.searchContent, ...courselist];
        } else {
          this.searchActive = false;
        }
        this.searchPage = ++this.searchPage;
        if (this.searchContent.length >= total) {
          this.finished = true;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
.search-result-wrap {
  padding-top: 46px;
}
</style>
